var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListViewIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3138",
    "data-name": "Rectangle 3138",
    width: 32,
    height: 32,
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "listViewIcons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8066",
    "data-name": "Group 8066",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3134",
    "data-name": "Rectangle 3134",
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 8,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 7,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3137",
    "data-name": "Rectangle 3137",
    width: 20,
    height: 8,
    rx: 2,
    transform: "translate(0 12)",
    fill: "#ccc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcons);
export default __webpack_public_path__ + "static/media/listViewIcons.69d3d81517ce2184a214e96a88add614.svg";
export { ForwardRef as ReactComponent };